export const ESPOT_MANUAL_APPROVAL_MESSAGE = 'ManualApprovalMessage';
export const CUSTOM_OUTAGE_MESSAGE = 'CUSTOM_OUTAGE_MESSAGE';
export const OUTAGE_MESSAGE_TYPE = 'OUTAGE_MESSAGE';
export const ALL_DEALER_ESPOT =
  'CATSAS_PCC_ALL_DEALER_CMC_ESPOT_OUTAGE_MESSAGE';

export const ESPOT_MANUAL_APPROVAL_MESSAGE_VIEWED = 'viewed';

export const SELECT_OR_ADD_EQUIPMENT = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240314-601e6-1c83d',
  alt: 'Select or Add Equipment',
  width: 180,
  height: 120
};

export const NO_EXACT_MATCH_IMAGE_SIZE = {
  width: 140,
  height: 93
};

export const DEEP_LINK_ROUTE = 'deeplink';
export const HOMEPAGE_SEARCH_BAR_BANNER = 'search-bar-banner-homepage';
export const HOMEPAGE_HERO_BANNER_BG_IMG =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240108-a7419-8d19b?fmt=webp';
export const MULTI_EQUIPMENT_ROUTE = 'multiEquipmentRoute';
export const NON_CAT_EQUIPMENT = 'qrCode';

export const GA_INVALID_SERAIL_SITES = {
  visionLinkAppReference: 'FleetManagement_SN',
  qrCodeAppReference: 'QRCode',
  visionLinkSiteValue: 'Vision Link'
};

export const GA_FORM_INVALID_SERIAL = {
  formName: 'QR code scan',
  formContent: 'Qr code scan',
  formFieldCausingError: 'serial number not matched',
  formLocation: 'PCC Home Page',
  formStatus: 'fail'
};

export const CMC_ESPOT_PCC_CATSAS_HOME_PAGE_MIDLEFT_INT =
  'CMC_ESPOT_PCC_CATSAS_HOME_PAGE_MIDLEFT_INT';
export const CMC_ESPOT_PCC_CATSAS_HOME_PAGE_MIDRIGHTTOP_INT =
  'CMC_ESPOT_PCC_CATSAS_HOME_PAGE_MIDRIGHTTOP_INT';
export const CMC_ESPOT_PCC_CATSAS_HOME_PAGE_MIDRIGHTBOTTOM_INT =
  'CMC_ESPOT_PCC_CATSAS_HOME_PAGE_MIDRIGHTBOTTOM_INT';
export const CMC_ESPOT_PCC_CATSAS_HOME_PAGE_BOTTOM_1_INT =
  'CMC_ESPOT_PCC_CATSAS_HOME_PAGE_BOTTOM-1_INT';
export const CMC_ESPOT_PCC_CATSAS_HOME_PAGE_BOTTOM_2_INT =
  'CMC_ESPOT_PCC_CATSAS_HOME_PAGE_BOTTOM-2_INT';
export const CMC_ESPOT_PCC_CATSAS_MIDDLE_DLR =
  'CMC_ESPOT_PCC_CATSAS_MIDDLE_DLR';

export const DEALER_MARKETING_OPTIN_INFO_CLAUSE_espot =
  'DEALER_MARKETING_OPTIN_INFO_CLAUSE_espot';
export const DEALER_LOCAL_COMPLIANCE_Details_espot =
  'DEALER_LOCAL_COMPLIANCE_Details_espot';

export const SOURCE_HOME = 'home';

export const CSP_PENDING_APPROVAL_MODAL = 'CSP_PENDING_APPROVAL_MODAL';

export const IMAGE_ALT_LABLE = 'Image for';

export const HOMEPAGE_CANONICAL_URL = 'https://parts.cat.com/{lang}/catcorp';

export const HOMEPAGE_ESPOTS = [
  CMC_ESPOT_PCC_CATSAS_MIDDLE_DLR,
  CMC_ESPOT_PCC_CATSAS_HOME_PAGE_BOTTOM_1_INT,
  CMC_ESPOT_PCC_CATSAS_HOME_PAGE_BOTTOM_2_INT,
  CMC_ESPOT_PCC_CATSAS_HOME_PAGE_MIDLEFT_INT,
  CMC_ESPOT_PCC_CATSAS_HOME_PAGE_MIDRIGHTBOTTOM_INT,
  CMC_ESPOT_PCC_CATSAS_HOME_PAGE_MIDRIGHTTOP_INT
].join(',');

export const HOMEPAGE_SHOPPING_EXPERIENCE_ESPOTS = [
  CMC_ESPOT_PCC_CATSAS_HOME_PAGE_MIDLEFT_INT,
  CMC_ESPOT_PCC_CATSAS_HOME_PAGE_MIDRIGHTBOTTOM_INT,
  CMC_ESPOT_PCC_CATSAS_HOME_PAGE_MIDRIGHTTOP_INT
];
